export default class extends Controller {
  static targets = ["progress", "filename"]

  connect() {
    addEventListener("direct-upload:start", this.onUploadStart.bind(this))
    addEventListener("direct-upload:progress", this.onUploadProgress.bind(this))
    addEventListener("direct-upload:error", this.onUploadError.bind(this))
    addEventListener("direct-upload:end", this.onUploadEnd.bind(this))
    App.Helpers.listenToCustomEvent(document, "direct-upload:pending", this.checkAndAdjustUploadID.bind(this))
    this.filenameTarget.textContent = this.filename
  }

  onUploadStart(event) {
    this.conditionallyDo(event, this.removePendingClass.bind(this))
  }

  removePendingClass(event) {
    this.element.classList.remove("upload--pending")
  }

  onUploadProgress(event) {
    this.conditionallyDo(event, this.updateProgressBar.bind(this))
  }

  updateProgressBar(event) {
    this.progressTarget.style.width = `${event.detail.progress}%`
  }

  onUploadError(event) {
    this.conditionallyDo(event, this.addErrorIndicators.bind(this))
  }

  addErrorIndicators(event) {
    event.preventDefault()
    this.element.classList.add("upload--error")
    this.element.setAttribute("title", event.detail.error)
  }

  onUploadEnd(event) {
    this.conditionallyDo(event, this.addCompleteClass.bind(this))
  }

  addCompleteClass(event) {
    this.element.classList.add("upload--complete")
  }

  checkAndAdjustUploadID(event) {
    const { fileID, formID } = event.detail
    if (formID === this.uploadID) {
      this.uploadID = fileID
    }
  }

  conditionallyDo(event, handler) {
    const { id } = event.detail
    if (id == this.uploadID) {
      setTimeout((() => handler(event)).bind(this), 100)
    }
  }

  get uploadID() {
    return this.data.get("upload-id")
  }

  set uploadID(val) {
    this.data.set("upload-id", val)
  }

  get filename() {
    return this.data.get("filename")
  }
}



// WEBPACK FOOTER //
// ./app/components/file_uploads/assets/javascript/file-uploads-pending-upload-controller.js